import { createSelector } from 'reselect';
import formatPropertySelectorCreator from './formatPropertySelectorCreator';
const getMinControlWidth = (state, props) => props.minControlWidth;
const formatWidth = formatPropertySelectorCreator('mdWidth');
const formatWebWidth = formatPropertySelectorCreator('web_mdWidth');
const getWidth = (state, props) => {
  // take for 'web_mdWidth' over 'mdWidth'
  const width = formatWebWidth(state, props) || formatWidth(state, props);
  // if width is defined, return a parsed integer
  if (width === undefined || width === null) {
    return undefined;
  }
  const parsed = parseInt(width, 10);
  // Return undefined if parsing resulted in NaN
  return Number.isNaN(parsed) ? undefined : parsed;
};

// Cache for width objects to ensure stable references
// Uses LRU eviction to prevent unbounded memory growth
// Key: size value (number), Value: { size: value } object
const MAX_CACHE_SIZE = 1000;
const widthObjectCache = new Map();

// Helper to get or create a cached width object
const getCachedWidthObject = size => {
  if (size === undefined || size === null) {
    return size; // Return primitive values as-is (not cached)
  }
  if (widthObjectCache.has(size)) {
    return widthObjectCache.get(size);
  }

  // If cache is full, remove oldest entry (first in Map)
  if (widthObjectCache.size >= MAX_CACHE_SIZE) {
    const firstKey = widthObjectCache.keys().next().value;
    widthObjectCache.delete(firstKey);
  }
  const cachedWidth = {
    size
  };
  widthObjectCache.set(size, cachedWidth);
  return cachedWidth;
};

// calculate md.size attribute
export default createSelector([getMinControlWidth, getWidth], (minControlWidth, width) => {
  // Return undefined as-is (not cached)
  if (width === undefined) {
    return width;
  }
  const minWidth = minControlWidth || 0;
  // check for a minimum width for the component.
  let widthToCalculate = width;
  if (width < minWidth) {
    widthToCalculate = minWidth;
  }
  const percentage = widthToCalculate / 100;
  const columns = percentage * 12;
  const gridCols = Math.round(columns);
  // Return cached object to ensure stable reference (including size 0)
  return getCachedWidthObject(gridCols);
});